import { useQuery } from "@apollo/client";
import { useNavigation } from "@react-navigation/native";
import {
  Divider,
  FlatListSearchable,
  Page,
  FlatActionList,
} from "@towersystems/roam-common-native";
import { Category } from "@towersystems/roam-common/lib/generated-types";
import React, { useCallback } from "react";
import { Text, View } from "react-native-ui-lib";
import { toTitleCase } from "../../utilities/to-title-case";
import { DEFAULT_CATEGORIES_OPTIONS, QueryCategories } from "./constants";
import { useCategoryListScreen } from "./hooks";

export function CategoryListScreen() {
  const { onSelect } = useCategoryListScreen();
  const navigation = useNavigation<any>();
  const [term, setTerm] = React.useState("");

  const { data, called, loading } = useQuery<{
    categories: {
      items: Category[];
    };
  }>(QueryCategories, {
    variables: {
      options: {
        ...DEFAULT_CATEGORIES_OPTIONS,
        filter: { name: { contains: term }, active: { eq: true } },
      },
    },
  });

  const searchItems = data?.categories.items || [];
  const items = loading ? [] : searchItems;

  const handleRenderItem = useCallback(({ item }: { item: Category }) => {
    return (
      <FlatActionList.RenderItem
        item={{
          key: item.id,
          title: toTitleCase(item.name),
          subTitle: item.description,
          onPress: () => handleCategorySelect(item),
        }}
      />
    );
  }, []);

  function handleCategorySelect(category: Category) {
    onSelect(category);
    navigation.goBack();
  }

  const emptyComponent =
    called && !loading ? <Text>No categories to show</Text> : undefined;

  console.log("FINDME", items);

  return (
    <Page titleContainerStyle={{ alignItems: "center" }}>
      <View>
        <FlatListSearchable
          placeholder="Search..."
          onChange={(query) => setTerm(query)}
          value={term}
          ItemSeparatorComponent={Divider}
          renderItem={handleRenderItem}
          refreshing={loading}
          data={items}
          scrollEnabled={false}
          ListEmptyComponent={emptyComponent}
        />
      </View>
    </Page>
  );
}
